import React from "react";
import { Link } from "react-router-dom";
import { Search, User, FileText, HelpCircle } from "lucide-react";

const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;

const QuickActions: React.FC = () => {
  const actions = [
    {
      label: "Find Projects",
      icon: Search,
      href: "/projects?tab=available",
      color: "bg-blue-500 hover:bg-blue-600",
      external: false,
    },
    {
      label: "My Profile",
      icon: User,
      href: "/profile",
      color: "bg-purple-500 hover:bg-purple-600",
      external: false,
    },
    {
      label: "Payments",
      icon: FileText,
      href: "/payments",
      color: "bg-green-500 hover:bg-green-600",
      external: false,
    },
    {
      label: "Help Center",
      icon: HelpCircle,
      href: `${FRONTEND_URL}/help`,
      color: "bg-orange-500 hover:bg-orange-600",
      external: true,
    },
  ];

  return (
    <div className="bg-white rounded-xl p-5 shadow-sm">
      <h3 className="font-semibold text-gray-900 mb-4">Quick Actions</h3>
      <div className="grid grid-cols-2 gap-3">
        {actions.map((action) =>
          action.external ? (
            <a
              key={action.label}
              href={action.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`${action.color} text-white rounded-lg p-3 flex flex-col items-center justify-center text-center transition-colors`}
            >
              <action.icon className="w-5 h-5 mb-1" />
              <span className="text-sm font-medium">{action.label}</span>
            </a>
          ) : (
            <Link
              key={action.label}
              to={action.href}
              className={`${action.color} text-white rounded-lg p-3 flex flex-col items-center justify-center text-center transition-colors`}
            >
              <action.icon className="w-5 h-5 mb-1" />
              <span className="text-sm font-medium">{action.label}</span>
            </Link>
          )
        )}
      </div>
    </div>
  );
};

export default QuickActions;
